/*
  This is the notification panel
 */

import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import store from "../store/store";

import URLService from "./services/URLService";
import {setGroupId} from "../store/details/patternDetailsSlice";
import {setElementGroupId, setLineNumberForNewQuoteItem, setQuoteItemId} from "../store/details/projectDetailsSlice";
import {
    saveQuote,
    setCurrentUrl,
    setElementSaveShouldUpdate,
    setReadyToSave,
    setSaving, setShouldRedirect
} from "../store/configuratorStateSlice";
import SavingLock from "./SavingLock";
import {checkQuickship} from "../store/configuratorStateSlice";

const SaveButtons = (props) => {
    const quantity = useSelector(state => state.projectDetailsReducer.quantity)
    const projectName = useSelector(state => state.projectDetailsReducer.projectName)
    const type = useSelector(state => state.projectDetailsReducer.projectType)
    const quoteItems = useSelector(state => state.projectDetailsReducer.quoteItems)
    const quoteItemId = useSelector(state => state.projectDetailsReducer.quoteItemId)
    const elementGroupId = useSelector(state => state.projectDetailsReducer.elementGroupId);

    const catalog_number = useSelector(state => state.summaryReducer.catalog_number)

    const isPattern = useSelector(state => state.configuratorStateReducer.isPattern)
    const hasElements = useSelector(state => state.configuratorStateReducer.hasElements);

    const groupId = useSelector(state => state.patternDetailsReducer.groupId)

    const readyToSave = useSelector(state => state.configuratorStateReducer.readyToSave);
    const dispatch = useDispatch();

    const [quickship, setQuickship] = useState("");
    const quickshipInt = useSelector(state => state.configuratorStateReducer.quickshipInt);

    const shouldRedirect = useSelector(state => state.configuratorStateReducer.shouldRedirect);
    const quoteId = useSelector(state => state.projectDetailsReducer.quoteId);
    const SAVEMODES = {
        close: 0,
        new: 1,
        duplicate: 2
    }

    const [saveMode, setSaveMode] = useState(SAVEMODES.close);

    useEffect(() => {
        if(shouldRedirect) {
            dispatch(setShouldRedirect(false));
            if(saveMode === SAVEMODES.close){
                URLService.redirect_to_quote(quoteId);
            } else if(saveMode === SAVEMODES.new){
                URLService.redirect_to_new_quote_item(quoteId);
            } else if(saveMode === SAVEMODES.duplicate){
                URLService.redirect_to_self_change_url(quoteId);
                dispatchDuplicateActions()
            }
        }
    }, [shouldRedirect])


    const scrollToTop = () => {
        $([document.documentElement, document.body]).animate({
            scrollTop: $('#configurator_main').offset().top
        }, 250);
    }

    const handleCancel = (e) => {
        e.preventDefault();
        URLService.redirect_to_home();
    }

    const getQuickship = async (e) => {
        if(e) {
            e.preventDefault();
        }
        await dispatch(checkQuickship())
    }

    const validate = async (e, mode) => {
        // here we validate fields and send errors if necessary
        e.preventDefault();
        store.dispatch({type: 'CLEAR_NOTICES'});

        let errors = [];
        if(projectName === ""){
            errors.push({type: 'project_name', message: 'Project name can\'t be blank.'});
        }

        if(type === ""){
            errors.push({type: 'type', message: 'Type can\'t be blank.'});
        }

        if(duplicate_quote_items()){
            const message = 'The line item contains the same Catalog Number and Type as another line. Please revise and retry.'
            errors.push({type: 'catalog_number', message: message});
        }

        if(quantity === ""){
            errors.push({type: 'quantity', message: 'Quantity can\'t be blank.'});
        } else if(isNaN(quantity)){
            errors.push({type: 'quantity', message: 'Quantity is not a number.'});
        } else if(quantity <= 0){
            errors.push({type: 'quantity', message: 'Quantity must be greater than 0.'});
        }

        if(errors.length !== 0) {
            // if errors are present set the flash errors
            setErrors(errors);
            scrollToTop();
        } else{
            //otherwise proceed to trigger api
            dispatch(setReadyToSave(false))
            dispatch(setSaving(true))
            setSaveMode(mode);

            // we want to add a quote_item to the list of quote items thus we can without calling api validated if this catalog number already exist
            store.dispatch({type: 'ADD_QUOTE_ITEM', catalog_number: catalog_number, quote_item_type: type});
            await dispatch(saveQuote());

        }
        return false; // this stops submit
    }

    const dispatchDuplicateActions  = () => {
        dispatch(setCurrentUrl(window.location.href));
        // Clear GroupId when with duplicating the patterns
        dispatch(setLineNumberForNewQuoteItem())
        dispatch(setGroupId(''));
        dispatch(setQuoteItemId(''));
        dispatch(setElementSaveShouldUpdate(false));
        dispatch(setElementGroupId(""));
        dispatch(setReadyToSave(true))
        dispatch(setSaving(false))
    }
    const setErrors = (errorArray) => {
        errorArray.forEach(function(err){
            // add errors to the store
            if( err.message && err.type) {
                store.dispatch({type: 'ADD_NOTICE', notice_type: err.type, message: err.message})
            } else {
                store.dispatch({type: 'ADD_NOTICE', notice_type: 'unknown', message: 'Unknown Error please contact support'})
            }
        });
    }

    // check wether current catalog_number and type already exist
    // this is a helper method for validation
    const duplicate_quote_items = () => {
        let dups = false;
        for(let object of quoteItems){
            // for patterns we compare GroupID
            if(isPattern) {
                if (object["catalog_number"] == catalog_number && object["quote_item_type"] == type && object['group_id'] != groupId) {
                    dups = true;
                }
            } else if(hasElements) {
                // elements use custom groups and require type to be unique
                if(object["quote_item_type"] == type &&  object['custom_group_id'] != elementGroupId && object["catalog_number"] == catalog_number) {
                    dups = true
                }
                // for non Pattern we compare QuoteItemID
            } else {
                if (object["catalog_number"] == catalog_number && object["quote_item_type"] == type && object['id'] != quoteItemId) {
                    dups = true;
                }
            }
        }
        return dups;
    }

    return (
        <div>
            <div className="small-12 columns buttons">
                <SavingLock />
                <button name="step_action" type="submit" value="save" className="button no-chevron configurator-action-button"
                        onClick={(e) => validate(e, SAVEMODES.close)}
                        disabled={!readyToSave}>
                    Save + Close
                </button>
                <button name="step_action" type="submit" value="save_and_new" className="button no-chevron configurator-action-button"
                        onClick={(e) => validate(e, SAVEMODES.new)}
                        disabled={!readyToSave}>Save + New
                </button>
                <button name="step_action" type="submit" value="save_and_copy" className="button no-chevron configurator-action-button"
                        onClick={(e) => validate(e, SAVEMODES.duplicate)}
                        disabled={!readyToSave}>
                    Save + Copy
                </button>
                <a className="button no-chevron configurator-action-button"
                              href=""
                              onClick={(e) => getQuickship(e)}
                disabled={quickship !== ""}>Check Quickship
                </a>
            </div>
        </div>
        )
}

export default SaveButtons;